(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const welcome = document.querySelector('[data-breathe-welcome]');

    if (welcome && !window.Shopify?.designMode) {
      const storageKey = 'breathe-welcome-seen-v2';
      const delay = Number(welcome.dataset.delay || 12) * 1000;
      const closeButtons = welcome.querySelectorAll('[data-breathe-welcome-close]');

      const closeWelcome = () => {
        if (typeof welcome.close === 'function' && welcome.open) welcome.close();
        welcome.removeAttribute('open');
        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          /* Storage can be unavailable in strict privacy modes. */
        }
      };

      closeButtons.forEach((button) => button.addEventListener('click', closeWelcome));
      welcome.addEventListener('click', (event) => {
        if (event.target === welcome) closeWelcome();
      });
      welcome.addEventListener('close', () => {
        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          /* Storage can be unavailable in strict privacy modes. */
        }
      });

      let hasSeenWelcome = false;
      try {
        hasSeenWelcome = window.sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        hasSeenWelcome = false;
      }

      if (!hasSeenWelcome) {
        window.setTimeout(() => {
          if (typeof welcome.showModal === 'function') {
            welcome.showModal();
          } else {
            welcome.setAttribute('open', '');
          }
        }, delay);
      }
    }

    const stickyBar = document.querySelector('[data-breathe-sticky-product]');
    const primaryProductButton = document.querySelector('.product__info-container .product-form__submit');

    if (stickyBar && primaryProductButton) {
      const stickyAction = stickyBar.querySelector('[data-breathe-scroll-buy]');
      let isPrimaryButtonVisible = false;
      const updateStickyState = () => {
        stickyBar.classList.toggle('is-visible', !isPrimaryButtonVisible && window.scrollY > 420);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          isPrimaryButtonVisible = entries[0].isIntersecting;
          updateStickyState();
        }, {
          threshold: 0.15,
        });
        observer.observe(primaryProductButton);
      }

      window.addEventListener('scroll', updateStickyState, { passive: true });

      stickyAction?.addEventListener('click', () => {
        primaryProductButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => primaryProductButton.focus({ preventScroll: true }), 450);
      });
    }
  });
})();
